<template>
  <div>
    <Breadcrumbs :items="items" />
      <v-sheet class="transparent-background-color">
        <v-sheet class="transparent-background-color page-card">
          <v-card>
          <v-card-title class="mx-3">
            {{  $t("Notification.ObjectName")  }}
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="$router.push('/#/')"
                >fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("SettingNav.backHome") }}
              </span>
            </v-tooltip>
          </v-card-title>
          <v-progress-linear :indeterminate="loading"></v-progress-linear>
         <div>
           <v-expansion-panels multiple accordion>
             <v-card width="100%">
               <v-card-text>
                 <v-timeline dense align-top class="py-0">
                   <v-slide-x-reverse-transition group hide-on-leave>
                     <v-timeline-item
                             v-for="(item, i) in this.announcement"
                             :key="i"
                             :color="item.base_announcement_account.is_read?'primary':'danger'"
                             icon="fa-bell"
                             fill-dot
                     >
                       <v-card color="#F5F5F5">
                         <v-card-title class="text-h6" @click.stop="showFullContent(i)" style="cursor:pointer">
                           {{ item.title }}
                           <v-icon v-if="!item.isFullContent" class="ml-2">fa-angle-double-down</v-icon>
                           <v-icon v-else class="ml-2">fa-angle-double-up</v-icon>
                         </v-card-title>
                         <v-card-text class=" text--primary">
                           <span v-if="!item.isFullContent">{{ item.short_content }}</span>
                           <span v-else v-html = item.content></span>
                           <v-row dense class="mt-10">
                             <v-col cols="12" sm="12" md="4">
                               <v-row dense align="center" class="pa-1">
                                 <span class="vertical-date small">
                                   {{ item.created_text }}<br />
                                   <span style="color:#1ab394">
                                     {{ item.created }}
                                   </span>
                                 </span>
                               </v-row>
                             </v-col>
                             <v-col cols="12" sm="12" md="8" align-self="center">
                               <v-row dense align="center" class="search-controls">
                                 <v-spacer />
                                 <!-- 标记已读 -->
                                 <v-btn
                                         small
                                         color="primary"
                                         dark
                                         class="ms-1"
                                         @click="isRead(item)"
                                         v-if="!item.base_announcement_account.is_read"
                                 >
                                   <v-icon x-small class="pe-1">fa-check</v-icon>
                                   {{ $t("Notification.read") }}
                                 </v-btn>
                               </v-row>
                             </v-col>
                           </v-row>
                         </v-card-text>
                       </v-card>
                     </v-timeline-item>
                   </v-slide-x-reverse-transition>
                 </v-timeline>
               </v-card-text>
             </v-card>
           </v-expansion-panels>
         </div>
          </v-card>
        </v-sheet>
        <v-sheet class="transparent-background-color page-opts">
          <v-card>
            <v-card-title>
              <v-row dense>
                <v-col cols="12">
                  <v-btn
                          outlined
                          color="secondary"
                          class="elevation-1"
                          block
                          :href="'/#/'"
                  >
                    <v-icon small class="pe-1">fa-times</v-icon>
                    {{ $t("SettingNav.backHome") }}
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn
                          color="primary"
                          block
                          @click="isRead({})"
                  >
                    {{ $t("Notification.allRead") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-sheet>
      </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import BaseAnnouncement from "@/api/base_announcement";

export default {
    components: {
        Breadcrumbs,
    },

    computed: {
        items: () => [
            {
                text: i18n.t("SettingNav.home"),
                disabled: false,
                href: "/home",
            },
            {
                text: i18n.t("App.notification"),
                disabled: true,
                href: "/notification",
            },
        ],
        accountID() {
            return this.accountInfo ? this.accountInfo.account_id : "";
        },
        enterpriseID() {
            return this.accountInfo ? this.accountInfo.enterprise_id : "";
        },
        accountUserID() {
            return this.accountUser ? this.accountUser.id : "";
        },
        accountUserName() {
            return this.accountUser ? this.accountUser.name : "";
        },
        ...mapState(["loading", "accountInfo", "accountUser"]),
    },

    data: () => ({
        announcement: [],
    }),

    mounted() {
        this.getAnnouncementFromAPI();
    },

    methods: {
        getAnnouncementFromAPI() {
            if (this.accountID != '') {
                BaseAnnouncement.fetchList({account_id: this.accountID}).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                          BaseAnnouncement.getUnreadBaseAnnouncementsCount({account_id: this.accountID})
                          this.announcement = response.data.baseAnnouncement;
                            this.announcement.forEach((column) => {
                                column['isFullContent'] = false
                            })
                        }
                    }.bind(this)
                );
            }
        },
        isRead(item) {
            let data = {
                account_id: this.accountID,
                enterprise_id: this.enterpriseID,
                login_user_id: this.accountUserID,
                login_user_name: this.accountUserName
            }
            if (item && Object.keys(item).length > 0) {
                data['announcement_id'] = item.id
            }
            BaseAnnouncement.readBaseAnnouncement(data).then(
                function (response) {
                    if (response.data.status.isOK()) {
                      this.getAnnouncementFromAPI()
                    }
                }.bind(this)
            );
        },
        showFullContent(announcementKey) {
            if (this.announcement[announcementKey].isFullContent) {
                this.announcement[announcementKey].isFullContent = false;
            } else {
                this.announcement[announcementKey].isFullContent = true
            }
            this.$forceUpdate();
        }
    },

    watch: {
        accountID() {
            this.getAnnouncementFromAPI();
        }
    }
};
</script>